import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import './programs.scss';
import MemberView from '../../components/member/member-view';

export interface Props extends RouteComponentProps<any> {}

const Members: React.FunctionComponent<Props> = (props) => {
  const {
    match: {
      params: { orgId, memberId },
    },
  } = props;

  return (
    <div id="member-view" className="container hub-full-width">
      <div className="page-content u-xs-padXl u-flexExpandSides">
        <div className="page-content-body">
          <MemberView orgId={+orgId} memberId={+memberId} />
        </div>
      </div>
    </div>
  );
};

export default Members;
